import React, { useState } from 'react';
import ExtinguisherForm from './components/ExtinguisherForm';
import MapDisplay from './components/MapDisplay';
import AdminDashboard from './components/AdminDashboard';
import LoginForm from './components/LoginForm';
import { AuthProvider, useAuth } from './context/AuthContext';
import './App.css';

function AppContent() {
  const { user, logout } = useAuth();
  const [showAdmin, setShowAdmin] = useState(false);

  return (
    <div className="App">
      <header className="header">
        <div className="container">
          <h1>🔥 FireWatch</h1>
          <p>Fire Extinguisher Tracking System</p>
          {user && (
            <div className="user-info">
              <span>Welcome, {user.username}</span>
              {user.role === 'admin' && (
                <button 
                  className="btn btn-secondary"
                  onClick={() => setShowAdmin(!showAdmin)}
                >
                  {showAdmin ? 'Public View' : 'Admin Dashboard'}
                </button>
              )}
              <button className="btn btn-secondary" onClick={logout}>
                Logout
              </button>
            </div>
          )}
        </div>
      </header>

      <div className="container">
        {!user ? (
          <LoginForm />
        ) : showAdmin && user.role === 'admin' ? (
          <AdminDashboard />
        ) : (
          <div className="main-content">
            <div className="form-section">
              <h2>Report Fire Extinguisher</h2>
              <ExtinguisherForm />
            </div>
            <div className="map-section">
              <MapDisplay />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;